<template>
    <div
        class="transition duration-100 fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center"
        :class="[open ? 'opacity-100 ' : 'pointer-events-none opacity-0']"
    >
        <div class="absolute w-full h-full bg-gray-900 opacity-50" />
        <div
            class="relative bg-white w-full mx-1 md:w-11/12 md:max-w-2xl md:mx-auto rounded shadow-lg px-4 md:px-8 pt-2 pb-6 z-50 overflow-y-auto"
        >
            <button
                @click="closeModal"
                class="absolute right-0 top-0 mt-4 mr-4 p-1 h-7 w-7 hover:bg-gray-200 rounded"
                :class="[closable ? '' : 'hidden']"
            >
                <svg
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </button>
            <h2 v-if="title" class="pt-2 text-xl font-medium text-gray-700">{{ title }}</h2>
            <slot name="header" />
            <div class="pt-2">
                <slot name="content" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'open', 'closable'],
    methods: {
        closeModal() {
            this.$emit('close')
        },
    },
}
</script>
